import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanUsuario } from 'src/bean/BeanUsuario';
import { environment } from 'src/environments/environment';
import { BeanAnswer } from './../../../bean/BeanAnswer';
import { BeanQuestion } from './../../../bean/BeanQuestion';

import { BeanContestation } from 'src/bean/BeanContestation';
import { BeanContestationAnswer } from 'src/bean/BeanContestationAnswer';
import { BeanMonitoryCommentReply } from 'src/bean/BeanMonitoryCommentReply';
import { BeanMonitoryParameter } from 'src/bean/BeanMonitoryParameter';
import { BeanMonitoryQuestionAnswer } from 'src/bean/BeanMonitoryQuestionAnswer';
import { BeanParametroXMotivoMoni } from 'src/bean/BeanParametroXMotivoMoni';
import { BeanRecording } from 'src/bean/BeanRecording';
import { BeanMonitoria } from '../../../bean/BeanMonitoria';
import { BeanMonitoryFiles } from '../../../bean/BeanMonitoryFiles';

@Injectable()

export class MonitoriaService {

  selectedIndex: number = 0;

  constructor(
    private http: HttpClient
  ) { }

  // METODO PARA ENVIAR E CONSULTAR O ARQUIVO PARA O SERVIDOR - RAFA
  // public  addAnexo():Observable<any>{
  public addAnexo(beanMonitoryFiles: BeanMonitoryFiles): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(beanMonitoryFiles);
    return this.http.post(`${environment.urlBackend}${environment.anexarArquivoMonitoria}`, json, { headers }).toPromise();
  }

  public addAnexoPlanoAcao(beanMonitoryFiles: BeanMonitoryFiles): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(beanMonitoryFiles);
    return this.http.post(`${environment.urlBackend}${environment.anexarArquivoMonitoria}`, json, { headers }).toPromise();
  }



  public buscarAnexo(moniIdCdMonitoria: string): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.buscarNomeArquivoMonitoria + moniIdCdMonitoria, { headers }).toPromise()
  }


  
  public downloadAnexo(moanIdCdMonitoriaAnexo: string): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.downloadArquivoMonitoria + moanIdCdMonitoriaAnexo, { headers }).toPromise()
  }



  public downloadAnexoContestacao(idContestacao: number): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.getContestacao + idContestacao, { headers }).toPromise()
  }



  public deletarAnexo(moanIdCdMonitoriaAnexo: string) {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.delete(environment.urlBackend + environment.deletarArquivoMonitoria + moanIdCdMonitoriaAnexo, { headers })
  }




  addMonitoria(newBeanMonitoria: BeanMonitoria): Promise<any> {
    return this.createMonitoria(newBeanMonitoria).toPromise().then((resposta: any) => resposta);
  }

  public createMonitoria(newBeanMonitoria: BeanMonitoria): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(newBeanMonitoria);
    return this.http.post(`${environment.urlBackend}${environment.criarMonitoria}`, json, { headers });
  }

  addContestacaoMonitoria(newBean: BeanContestation): Promise<any> {
    return this.createContestationMonitoria(newBean).toPromise().then((resposta: any) => resposta);

  }

  public createContestationMonitoria(newBean: BeanContestation): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(newBean);
    return this.http.post(`${environment.urlBackend}${environment.criaContestacao}`, json, { headers });
  }


  //update contestacao
  atualizarContestacaoMonitoria(newBean: BeanContestation): Promise<any> {
    return this.updateContestacaoMonitoria(newBean).toPromise().then((resposta: any) => resposta);

  }

  public updateContestacaoMonitoria(newBean: BeanContestation): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(newBean);
    return this.http.put(`${environment.urlBackend}${environment.updateContestacao}${newBean.contIdCdContestacao}`, json, { headers })
  }


  addRespostaContestacaoMonitoria(newBean: BeanContestationAnswer): Promise<any> {
    return this.createRespostaContestationMonitoria(newBean).toPromise().then((resposta: any) => resposta);
  }

  public createRespostaContestationMonitoria(newBean: BeanContestationAnswer): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(newBean);
    return this.http.post(`${environment.urlBackend}${environment.criaRespostaContestacao}`, json, { headers });
  }

  createUpdateMonitoriaParametros(lstBeanMonitoryParameter: BeanMonitoryParameter[] = []): Promise<BeanMonitoryParameter[]> {
    return this.createUpdateParametros(lstBeanMonitoryParameter).toPromise().then((resposta: BeanMonitoryParameter[]) => resposta);
  }

  public createUpdateParametros(lstBeanMonitoryParameter: BeanMonitoryParameter[] = []): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };


    let json = JSON.stringify(lstBeanMonitoryParameter);

    return this.http.post(`${environment.urlBackend}${environment.criateUpdateMonitoriaParametro}`, json, { headers });
  }



  public listarAssistente(idOperacao: string, idGestao: string, isAtivo: boolean): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.listarAssistentePorOperacaoGestor + "/" + idOperacao + "/" + idGestao + "/" + isAtivo, { headers }).toPromise().then((resposta: any) => resposta)
  }

  public listarMonitoria(idAssistente: string, idStatus: string, dateDe: string, dateAte: string, tipoFicha: string): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.listarMonitorias + "?operatorId=" + idAssistente + "&statusId=" + idStatus + "&startDate=" + dateDe + "&endDate=" + dateAte + "&formType=" + tipoFicha, { headers }).toPromise().then((resposta: any) => resposta);
  }



  public listarStatusPorParametroMonitoria(idPamo: number): Promise<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.getMotiveParameterMoniByPamo + idPamo, { headers }).toPromise().then((resposta: any) => resposta)
  }


  public listarMonitoriaById(idMonitoria: string): Promise<BeanMonitoria> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    return this.http.get(environment.urlBackend + environment.listarMonitoriaById + "/" + idMonitoria, { headers }).toPromise().then((resposta: any) => resposta)
  }

  public criaMonitoryQuestionAnswer(bean: BeanMonitoryQuestionAnswer): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(bean);
    return this.http.post(environment.urlBackend + environment.criaMonitoriaPergResp, json, { headers })
  }

  public criaMonitoryQuestionAnswerByList(beanList: BeanMonitoryQuestionAnswer[], moniIdCdMonitoria: number): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(beanList);
    return this.http.post(environment.urlBackend + environment.criaMonitoriaPergRespList + moniIdCdMonitoria, json, { headers })
  }


  public criarMotiveParameterMonitory(bean: BeanParametroXMotivoMoni): Observable<any> {
    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };
    let json = JSON.stringify(bean);
    return this.http.post(environment.urlBackend + environment.criaMotiveParameterMoni, json, { headers })
  }


  carregaMonitoria(idMonitoria: number, idUserLogado: number, tipoUsuarioLogado: number): Promise<any> {
    return this.carregarMonitoria(idMonitoria, idUserLogado, tipoUsuarioLogado).toPromise().then((resposta: any) => resposta);
  }


  public carregarMonitoria(idMonitoria: number, idUserLogado: number, tipoUsuarioLogado: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.carregaMonitoriaWithoutQuestions + idMonitoria + "/"+idUserLogado+ "/"+tipoUsuarioLogado, { headers })

  }



  carregarPontosPorAgrupador(idMonitoria: number): Promise<any> {
    return this.carregarPontosPorGrupoCategoria(idMonitoria).toPromise().then((resposta: any) => resposta);
  }


  public carregarPontosPorGrupoCategoria(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.carregaPontosPorGrupoCategoria + idMonitoria, { headers })

  }


  /**
  carregaMonitoriaByRe(re: string, idStatus :string,  dateDe : string, dateAte: string):Promise<any>{
    return this.carregarMonitoriaByRe(re, idStatus, dateDe, dateAte).toPromise().then((resposta:any) => resposta);
  }


  public carregaMonitoriaByRe(re: string, idStatus :string, dateDe : string, dateAte: string): Promise<any>{

      const tokenString = localStorage.getItem('access_token');


      const headers = {
          'Authorization' : 'Bearer ' + tokenString,
          'Content-Type': 'application/json'
          };
      return this.http.get(environment.urlBackend +  environment.carregaMonitoriabyRe + "?id="+re + "&statusId=" + idStatus + "&dataDe="+dateDe+ "&dataAte="+dateAte, {headers}).toPromise().then((resposta:any) => resposta)

  }*/





  getNrPointsOfMonitory(idMonitoria: number, formDsTipoPontuacao: string): Promise<any> {

    if (formDsTipoPontuacao == "SOMA") {
      return this.carregarPontosDaMonitoriaSoma(idMonitoria).toPromise().then((resposta: any) => resposta);
    } else if (formDsTipoPontuacao == "MEDIA") {
      return this.carregarPontosDaMonitoriaMedia(idMonitoria).toPromise().then((resposta: any) => resposta);
    }

  }


  getNrExtraPointsOfMonitory(idMonitoria: number, formDsTipoPontuacao: string): Promise<any> {

    return this.carregarPontosExtrasDaMonitoriaMedia(idMonitoria).toPromise().then((resposta: any) => resposta);


  }


  public carregarPontosDaMonitoriaSoma(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.nrPoitsMonitoriaSoma + idMonitoria, { headers })

  }

  public carregarPontosDaMonitoriaMedia(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.nrPoitsMonitoriaMedia + idMonitoria, { headers })

  }


  public carregarPontosExtrasDaMonitoriaMedia(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.nrExtraPoitsMonitoria + idMonitoria, { headers })

  }


  getNrRespostasZeradasGraveMonitory(idMonitoria: number): Promise<any> {
    return this.carregarQtdRespostasZeradasGraveMonitoria(idMonitoria).toPromise().then((resposta: any) => resposta);
  }

  public carregarQtdRespostasZeradasGraveMonitoria(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.nrZeradosGraveMonitoria + idMonitoria, { headers })

  }

  getNrRespostasZeradasNaoGraveMonitory(idMonitoria: number): Promise<any> {
    return this.carregarQtdRespostasZeradasNaoGraveMonitoria(idMonitoria).toPromise().then((resposta: any) => resposta);
  }

  public carregarQtdRespostasZeradasNaoGraveMonitoria(idMonitoria: number): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend + environment.nrZeradosNaoGraveMonitoria + idMonitoria, { headers })

  }

  public atualizaMonitoryQuestionAnswer(beanMonitoryQA: BeanMonitoryQuestionAnswer): Observable<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    let json = JSON.stringify(beanMonitoryQA);

    return this.http.put(environment.urlBackend + environment.atualizaMonitoryQuestionAnswer + beanMonitoryQA.permNrSequencia, json, { headers })

  }

  public getHeaders() {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public getComentario(idMonitoria: number, idGrupoCategoria: number, idCategoria: number, idPergunta: number): Promise<any> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getComment}${idMonitoria}/${idGrupoCategoria}/${idCategoria}/${idPergunta}`, { headers })
      .toPromise()
      .then((resposta: any) => resposta);
  }

  updateComentario(beanMonitoryCommentReply: BeanMonitoryCommentReply): Promise<any> {
    return this.atualizarComentario(beanMonitoryCommentReply).toPromise().then((resposta: any) => resposta);
  }

  public atualizarComentario(beanMonitoryCommentReply: BeanMonitoryCommentReply): Observable<any> {
    const headers = this.getHeaders();
    let json = JSON.stringify(beanMonitoryCommentReply);
    return this.http.put(`${environment.urlBackend}${environment.updateComment}${beanMonitoryCommentReply.recmNrSequencia}`, json, { headers })
  }

  public getPergunta(idPergunta: number): Promise<BeanQuestion> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getPergunta}${idPergunta}`, { headers }).toPromise().then((resposta: any) => resposta);
  }

  public getResposta(idResposta: number): Promise<BeanAnswer> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getResposta}${idResposta}`, { headers }).toPromise().then((resposta: any) => resposta);
  }

  public getPessoa(idUsuario: number): Promise<BeanUsuario> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getUserComment}${idUsuario}`, { headers }).toPromise().then((resposta: any) => resposta);
  }

  addComentario(beanMonitoryCommentReply: BeanMonitoryCommentReply): Promise<any> {
    return this.criaComentario(beanMonitoryCommentReply).toPromise().then((resposta: any) => resposta);
  }

  public criaComentario(beanMonitoryCommentReply: BeanMonitoryCommentReply): Observable<any> {

    const headers = this.getHeaders();

    let json = JSON.stringify(beanMonitoryCommentReply);

    return this.http.post(`${environment.urlBackend}${environment.criarComment}`, json, { headers });
  }


  //TRAZER TODAS AS CONFIGURAÇÕES DO GRUPO DE [Prazos e períodos]
  public buscarConfiguracaoTempoDeOperacao(idGrupoConfig: number): Promise<any> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getConfiguracaoPorGrupo}${idGrupoConfig}`, { headers }).toPromise().then((resposta: any) => resposta);
  }


  public buscarTempoUsuarioOperacao(dateTime: string): Promise<any> {
    const headers = this.getHeaders();
    return this.http.get(`${environment.urlBackend}${environment.getTempoUsuarioOperacao}${dateTime}`, { headers }).toPromise().then((resposta: any) => resposta);
  }

  public geraGravacaoPorMonitoria(beanRecording: BeanRecording): Promise<any> {

    const tokenString = localStorage.getItem('access_token');


    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };


    let json = JSON.stringify(beanRecording);

    return this.http.post(`${environment.urlBackend}${environment.geraGravacaoPorMonitoria}`, json, { headers }).toPromise().then((resposta: any) => resposta);
  }

  public buscarExportacao(idOperCdOperacao: string, expoDsAgente: any, expoDsTipoLigacao: string): Promise<any> {
    const headers = this.getHeaders();
    const params = new HttpParams()
      .set("idOperCdOperacao", idOperCdOperacao)
      .set("expoDsAgente", expoDsAgente)
      .set("expoDsTipoLigacao", expoDsTipoLigacao);

    return this.http.get(`${environment.urlBackend}${environment.getExport}`, { headers, params }).toPromise().then((resposta: any) => resposta);
  }

  public buscarPorFiltros(operIdCdOperacao: string, formIdCdFormulario: string, usuaIdCdOperador: string, usuaIdCdGestor: string, moniDhMonitoriaDE: string, moniDhMonitoriaATE: string) {

    const headers = this.getHeaders();
    const params = new HttpParams()
      .set("operIdCdOperacao", operIdCdOperacao)
      .set("formIdCdFormulario", formIdCdFormulario)
      .set("usuaIdCdOperador", usuaIdCdOperador)
      .set("usuaIdCdGestor", usuaIdCdGestor)
      .set("moniDhMonitoriaDE", moniDhMonitoriaDE)
      .set("moniDhMonitoriaATE", moniDhMonitoriaATE);

    return this.http.get(`${environment.urlBackend}${environment.listarMonitoriasFiltradas}`, { headers, params }).toPromise().then((resposta: any) => resposta);
  }

  public listarFormulariosOperacaoFicha(operIdCdOperacao: any, tipoFicha: string) {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarFormulariosOperacaoFicha}/${operIdCdOperacao}/${tipoFicha}`, { headers }).toPromise().then((resposta) => resposta);
  }

  public createRegularAppraiser(regularAppraiser: any): Promise<any> {

    const headers = this.getHeaders();

    let json = JSON.stringify(regularAppraiser);

    return this.http.post(`${environment.urlBackend}${environment.regularAppraiser}`, json, { headers }).toPromise().then((resposta: any) => resposta);
  }

  public getRegularAppraiserByMonitory(moniIdCdMonitory: any) {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.regularAppraiser}${environment.getByIdMonitory}${moniIdCdMonitory}`, { headers });
  }

}
